import { G2TooltipCfg, LineFillColorCfg } from '@/types/common/g2Charts'

// cart 基本配置
export const g2DefaultCfg = {
  chartCfgFn: (padding: number[] = [50], height = 350) => ({
    autoFit: true,
    padding: padding,
    height: height
  }),

  defaultFill: '#eeeeee',

  colorList: () => {
    return ['#91e5f6', '#84d2f6', '#59a5d8', '#386fa4', '#133c55',
      '#ece6bc', '#fdc75c', '#ff8c10', '#db3d3d', '#004b73']
  },

  lineFillColorFn: (): LineFillColorCfg => ({
    line: '#A2CAA5',
    bar: '#6095FD'
  }),

  //   标注样式设置
  annotationTextFn: ({ style = {}, offsetY = -20, offsetX = -50 } = {}) => ({
    style: {
      fill: '#8c8c8c',
      fontWeight: 700,
      ...style
    },
    offsetY,
    offsetX
  }),

  //   缩略轴样式
  sliderFn: () => ({
    start: 0.5,
    end: 1,
    padding: [0, 0, 0, 0],
    trendCfg: {
      isArea: false
    }
  }),

  // Y轴样式设置
  YAxisFn: () => ({
    nice: true,
    line: {
      style: {
        stroke: '#D9D9D9'
      }
    },
    tickLine: {
      style: {
        stroke: '#D9D9D9'
      }
    },
    grid: null
  }),

  //   自定义 tooltip （基础图形）
  tooltipText: (title: string, data: G2TooltipCfg[], name: string) => {
    let html = ''
    data.forEach((item: G2TooltipCfg) => {
      const { color, value } = item
      html += `
        <div class="g2-tooltip-title">${title}</div>
        <ul class="g2-tooltip-list">
            <li class="g2-tooltip-list-item">
                <span class="g2-tooltip-marker" style="background-color: ${color};"></span>
                <span class="g2-tooltip-name">${name}</span>:<span class="g2-tooltip-value">${value}</span>
            </li>
        </ul>
      `
    })
    return html
  },

  //   自定义 tooltip （基础图形）
  tooltipText3: (title: string, data: G2TooltipCfg[], nameNext = '') => {
    let html = ''
    data.forEach((item: G2TooltipCfg) => {
      const { color, name, value } = item
      html += `
            <li class="g2-tooltip-list-item">
                <span class="g2-tooltip-marker" style="background-color: ${color};"></span>
                <span class="g2-tooltip-name">${name}${nameNext}</span>:<span class="g2-tooltip-value">${value}</span>
            </li>
          `
    })
    return `<div class="g2-tooltip-title">${title}</div>
            <ul class="g2-tooltip-list">
              ${html}
            </ul>`
  },

  //   自定义 tooltip （双Y轴图形）
  tooltipText2 (
    title: string,
    _data: G2TooltipCfg[],
    name1: string,
    name2: string,
    LChartType?: string,
    RChartType?: string
  ) {
    let html = ''
    const { bar, line } = g2DefaultCfg.lineFillColorFn()
    _data.forEach((item: G2TooltipCfg) => {
      const { data } = item
      html += `
      <div class="g2-tooltip-title">${title}</div>
      <ul class="g2-tooltip-list">
          <li class="g2-tooltip-list-item">
              <span class="g2-tooltip-marker" style="background-color: ${LChartType === 'Line' ? line : bar}"></span>
              <span class="g2-tooltip-name">${name1}</span>:<span class="g2-tooltip-value">${data.YLeft}</span>
          </li>
          <li class="g2-tooltip-list-item">
              <span class="g2-tooltip-marker" style="background-color: ${RChartType === 'Line' ? line : bar};"></span>
              <span class="g2-tooltip-name">${name2}</span>:<span class="g2-tooltip-value">${data.YRight}</span>
          </li>
      </ul>
      `
    })
    return html
  }
}

// 获取y轴字段
export const getAxisYName = (str: string) => str.split('*')[1]
